export default __webpack_public_path__ + "static/media/car11.f755559e.png";